import { accessToken } from "../components/core/auth-service/auth-service";
import { GET_CREDIT_LIMIT_START, GET_CREDIT_LIMIT_SUCCESS, GET_CREDIT_LIMIT_FAILURE } from "./actionTypes";
import getConfig from '../environment';

export const getCreditLimitBegin = () => ({
  type: GET_CREDIT_LIMIT_START,
  payload: {}
});

export const getCreditLimitSuccess = (creditLimitResponse:any) =>({
  type: GET_CREDIT_LIMIT_SUCCESS,
  payload: { creditLimitResponse }
});

export const getCreditLimitFailure = (errors:any) => ({
  type: GET_CREDIT_LIMIT_FAILURE,
  payload: { errors }
});

const CREDIT_LIMIT_API = getConfig()?.creditLimitApi;

export async function getCreditLimitFromApi(dispatch:any, baseSiteUID:string, salesAreaDependantCustomerUid:string) {
  const creditLimitApi = `${CREDIT_LIMIT_API}/credit-limit`;
  console.log(`Bearer ${await accessToken()}`)
  dispatch(getCreditLimitBegin())
  return fetch(creditLimitApi, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'PT-Base-Site-UID': `${baseSiteUID}`,
      'PT-Sales-Area-Dependent-Customer-Uid': `${salesAreaDependantCustomerUid}`,
    }
  })
    .then(response => response.json())
    .then(response => {
      dispatch(getCreditLimitSuccess(response))
    })
    .catch(error => {
      dispatch(getCreditLimitFailure(error))
    })
}
